var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSegAddOn = function SvgSegAddOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 119-9 9.01 9.01 0 01-9 9zm-2-2.209a2 2 0 004 0v-8.756l3.173 3.173a2 2 0 102.834-2.824l-6.59-6.59a1.997 1.997 0 00-2.823-.001l-6.6 6.58a1.997 1.997 0 102.822 2.826L10 10.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.727 5.24L5.252 7.705A8.067 8.067 0 017.727 5.24m8.556.006a8.063 8.063 0 012.472 2.473l-2.473-2.473M9 12.435v6.356a2.998 2.998 0 00.072.654 8.043 8.043 0 01-4.63-4.819 3.003 3.003 0 003.08-.718L9 12.436m6 .014l1.466 1.465a2.984 2.984 0 002.124.879 3.016 3.016 0 00.963-.157 8.042 8.042 0 01-4.625 4.808 2.998 2.998 0 00.072-.654V12.45M12 2a10 10 0 1010 10A10 10 0 0012 2zM5.405 12.784A.998.998 0 014.7 11.08l6.6-6.58a.996.996 0 011.41 0l6.59 6.59a1 1 0 01-1.42 1.41L13 7.621v11.17a1 1 0 01-2 0V7.621l-4.89 4.87a.994.994 0 01-.705.293z"
  })));
};
export default SvgSegAddOn;